import React from 'react';
import { useLang } from '../../context/LangContext';
import { Lang } from '../../types';

const LANGS: Lang[] = ['ro', 'en'];

export default function LangSwitcher() {
  const { lang, switchLang } = useLang();
  return (
    <div className="flex items-center gap-0.5 bg-white/[0.07] border border-white/[0.12] rounded-full px-2 py-1">
      {LANGS.map((l, i) => (
        <React.Fragment key={l}>
          {i > 0 && <span className="text-white/20 text-[0.7rem] select-none">|</span>}
          <button
            onClick={() => switchLang(l)}
            className={`font-syne text-[0.75rem] font-bold tracking-widest uppercase px-2 py-1 rounded-full transition-all duration-200
              ${lang === l ? 'bg-teal text-navy' : 'text-silver hover:text-white'}`}>
            {l.toUpperCase()}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
}
